// src/pages/legal/CancellationPolicy.js
import React from 'react';
import { useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling

const CancellationPolicy = () => {
  const { lang } = useParams();
  // You would paste your HTML content here
  const cancellationHtml = `
   <h1>Cancellation Policy — SeegSoog.com</h1>
  <p><strong>Effective Date:</strong> December 11, 2025</p>
  <p>SeegSoog.com is operated by Log-Inn the Smart Home Ltd., Company Registration Number 514147305, Israel. This Cancellation Policy applies to the operations of Log-Inn the Smart Home Ltd. on SeegSoog.com.</p>

  <h2>1. Free Access</h2>
  <p>Registration and use of basic features (e.g. browsing listings, saving properties) are free. Canceling your account does not incur any charges or refunds.</p>

  <h2>2. Promoted Listings</h2>
  <ul>
    <li>Listings may be promoted through the property edit page.</li>
    <li>Promotion requires payment and becomes active immediately.</li>
    <li><strong>All promotion sales are final.</strong> No refunds are provided once the listing is promoted.</li>
  </ul>

  <h2>3. Paid Reports</h2>
  <ul>
    <li>Reports purchased through the platform are delivered via email or directly through your account.</li>
    <li><strong>Once a report is sent, the transaction is final and non-refundable.</strong></li>
    <li>For technical issues with delivery, contact support promptly for assistance.</li>
  </ul>

  <h2>4. Lead Purchases (for Providers)</h2>
  <ul>
    <li>Providers may purchase leads to contact potential Investors.</li>
    <li>A refund for a purchased lead, in the form of platform credits, may be requested within 72 hours if the lead is invalid. A lead is considered invalid if contact cannot be established using <strong>both</strong> the provided email and phone number.</li>
    <li>All refund requests are subject to review and approval at our discretion.</li>
  </ul>

  <h2>5. Listing and Account Deletion</h2>
  <ul>
    <li>Providers may delete or unpublish listings at any time, but this will not result in a refund for active promotions or reports.</li>
    <li>Deleting an account removes access to all features and data, without refunding any previously paid services.</li>
  </ul>

  <h2>6. Termination for Violations</h2>
  <p>Accounts or listings violating our <a href="/${lang}/terms-of-use">Terms of Use</a> may be suspended or terminated. No refunds will be issued in such cases.</p>

  <h2>7. Dispute Resolution</h2>
  <p>For exceptions or concerns regarding cancellations, please use our <a href="/${lang}/contact-us">Contact Us</a> page. We’ll review your inquiry carefully.</p>  `;

  return (
    <div className="legal-page-container">
      <div className="legal-content" dangerouslySetInnerHTML={{ __html: cancellationHtml }} />
    </div>
  );
};

export default CancellationPolicy;
